var _defs, _path, _ellipse, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFriendIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 265.22 265.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-4);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 132.61,
    x2: 265.22,
    y2: 132.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f8eb30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#28a8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65308f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 83.34,
    y1: 199.63,
    x2: 211.45,
    y2: 199.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 116.04,
    y1: 98.26,
    x2: 178.75,
    y2: 98.26,
    gradientTransform: "translate(112.65 -75.45) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 33.83,
    y1: 123.02,
    x2: 98.62,
    y2: 123.02,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m132.61,0C59.49,0,0,59.49,0,132.61s59.49,132.61,132.61,132.61,132.61-59.49,132.61-132.61S205.73,0,132.61,0Zm0,264.22C60.04,264.22,1,205.18,1,132.61S60.04,1,132.61,1s131.61,59.04,131.61,131.61-59.04,131.61-131.61,131.61Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 147.4,
    cy: 199.63,
    rx: 64.05,
    ry: 61.34
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 147.4,
    cy: 98.26,
    r: 31.36,
    transform: "translate(-26.31 133) rotate(-45)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m98.62,123.6v-1.17c0-2.9-2.35-5.25-5.25-5.25h-21.3v-21.3c0-2.9-2.35-5.25-5.25-5.25h-1.17c-2.9,0-5.25,2.35-5.25,5.25v21.3h-21.3c-2.9,0-5.25,2.35-5.25,5.25v1.17c0,2.9,2.35,5.25,5.25,5.25h21.3v21.3c0,2.9,2.35,5.25,5.25,5.25h1.17c2.9,0,5.25-2.35,5.25-5.25v-21.3h21.3c2.9,0,5.25-2.35,5.25-5.25Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendIcon);
export default __webpack_public_path__ + "static/media/friend-icon.9bf0dd55f9460caaa6f7eb3f4e2f6561.svg";
export { ForwardRef as ReactComponent };